module.exports = __webpack_public_path__ + "c684e2d99c79166e5ce8ceb7e6189d36.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-account/details/account-details.html
// module id = 1743
// module chunks = 0